export default "__VITE_ASSET__DMId8map__"